import { NgModule } from '@angular/core';
import { CesBaseButtonComponent } from './ces-base-button.component';
import { CesButtonSecondaryComponent } from './ces-button-secondary.component';
import { CesButtonTertiaryWhiteComponent } from './ces-button-tertiary-white.component';
import { CesButtonTertiaryComponent } from './ces-button-tertiary.component';
import { CesButtonComponent } from './ces-button.component';
import { CesConfirmationButtonComponent } from './ces-confirmation-button.component';
import { CesDeleteButtonComponent } from './ces-delete-button.component';
import { CesMenuButtonSecondaryComponent } from './ces-menu-button-secondary.component';
import { CesMenuButtonComponent } from './ces-menu-button.component';
import { CesNavItemButtonComponent } from './ces-nav-item-button.component';
import { CesSidebarButtonComponent } from './ces-sidebar-button.component';
import { CesToolbarButtonComponent } from './ces-toolbar-button.component';

const COMPONENTS = [
  CesBaseButtonComponent,
  CesButtonSecondaryComponent,
  CesButtonTertiaryComponent,
  CesButtonTertiaryWhiteComponent,
  CesButtonComponent,
  CesConfirmationButtonComponent,
  CesDeleteButtonComponent,
  CesMenuButtonSecondaryComponent,
  CesMenuButtonComponent,
  CesNavItemButtonComponent,
  CesSidebarButtonComponent,
  CesToolbarButtonComponent,
];

@NgModule({
  imports: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class CesButtonsModule {}
